import type { ComponentProps } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { Badge } from "~/components/ui/badge";
import {
  gliderStatusToneClassNames,
  type GliderStatusTone,
} from "~/lib/glider-color-tokens";
import { cn } from "~/lib/utils";

const statusPillVariants = cva(
  "glider-status-pill-tone inline-flex h-6 items-center rounded-full border border-[var(--glider-tone-border)] bg-[var(--glider-tone-bg)] px-3 py-1 text-caption font-medium text-[var(--glider-tone-fg)]",
  {
    variants: {
      tone: gliderStatusToneClassNames,
    },
    defaultVariants: {
      tone: "default",
    },
  },
);

export type StatusPillTone = GliderStatusTone;

type StatusPillProps = Omit<ComponentProps<typeof Badge>, "variant"> &
  VariantProps<typeof statusPillVariants>;

export function StatusPill({
  className,
  tone = "default",
  ...props
}: StatusPillProps) {
  return (
    <Badge
      className={cn(statusPillVariants({ tone }), className)}
      variant="outline"
      {...props}
    />
  );
}
